// extracted by mini-css-extract-plugin
export var activeFilterButton = "_om-c";
export var backButton = "_om-4";
export var backIcon = "_om-5";
export var chevronShortcut = "_om-6";
export var container = "_om-1";
export var editor = "_om-8";
export var editorWrapper = "_om-7";
export var prefix = "_om-2";
export var searchIcon = "_om-3";
export var suffix = "_om-9";
export var suffixContent = "_om-a";
export var suffixText = "_om-b";
export var wrapper = "_om-0";